export default __webpack_public_path__ + "static/media/respect.d166624e.svg";